import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useHover } from '@helsenorge/designsystem-react';
import { trackNavigation } from '@helsenorge/framework-utils/adobe-analytics';
import { LinkContent } from './link-content';
import { useReturUrl } from './useReturUrl';
import styles from './styles.module.scss';
const Breadcrumb = ({ homeLabel, homeUrl, link, ariaLabel = 'Brødsmulesti' }) => {
    const { hoverRef, isHovered } = useHover();
    const { returUrl, returUrlTekst } = useReturUrl() || {};
    if (!homeLabel || !homeUrl) {
        return null;
    }
    const handleLinkClick = () => trackNavigation('brødsmulesti', link ? link.name : homeLabel, 'brødsmulesti');
    const getLink = () => {
        if (returUrl && returUrlTekst) {
            return (_jsx("a", { ref: hoverRef, className: styles.breadcrumb__link, href: returUrl, onClick: handleLinkClick, children: _jsx(LinkContent, { isHovered: isHovered, children: returUrlTekst }) }));
        }
        else if (link?.renderAsRouterLink) {
            return (_jsx(Link, { ref: hoverRef, className: styles.breadcrumb__link, to: link.url, onClick: handleLinkClick, children: _jsx(LinkContent, { isHovered: isHovered, children: link?.name || homeLabel }) }));
        }
        return (_jsx("a", { ref: hoverRef, className: styles.breadcrumb__link, href: link?.url ?? homeUrl, onClick: handleLinkClick, children: _jsx(LinkContent, { isHovered: isHovered, children: link?.name || homeLabel }) }));
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.border }), _jsx("div", { className: 'container', children: _jsx("div", { className: 'row', children: _jsx("div", { className: 'col', children: _jsx("nav", { className: styles.breadcrumb__content, "aria-label": ariaLabel, children: getLink() }) }) }) }), _jsx("div", { className: styles.border })] }));
};
export default Breadcrumb;
